import React, { forwardRef } from "react";
import { Popper, PopperBaseProps } from "../Popper";
import { MenuList, MenuListProps } from "./MenuList";

export interface MenuProps extends PopperBaseProps, MenuListProps {}

export const Menu = forwardRef(
  ({ anchorEl, open, placement, options, onClickOutside, ...props }, ref) => {
    return (
      <Popper
        disablePortal
        anchorEl={anchorEl}
        open={open}
        placement={placement}
        options={options}
        onClickOutside={onClickOutside}
      >
        <MenuList ref={ref} {...props} />
      </Popper>
    );
  },
) as React.ForwardRefExoticComponent<MenuProps>;
